/**
 * calculator-popup.js
 * wholesalemoulding.ca
 *
 * Handles the ❓ info popup that appears on all product pages.
 * Shows: Shipping info + Non-refundable policy + Customer initials acknowledgment
 * The Add to Cart button is locked until the customer acknowledges.
 */

(function () {
  'use strict';

  var ACKNOWLEDGED_KEY = 'mm_acknowledged';
  var MODAL_ID = 'calc-info-modal';

  /* ─────────────────────────────────────────
     BUILD MODAL HTML
  ───────────────────────────────────────── */

  function buildModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'calc-popup-overlay';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'calc-popup-title');
    modal.style.display = 'none';

    modal.innerHTML = [
      '<div class="calc-popup">',

      '  <button class="calc-popup__close" id="calc-popup-close" type="button" aria-label="Close">',
      '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
      '  </button>',

      '  <h2 id="calc-popup-title" class="calc-popup__title">',
      '    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
      '    Ordering &amp; Shipping Information',
      '  </h2>',

      '  <div class="calc-popup__section">',
      '    <h3 class="calc-popup__section-title">📦 Pick-Up &amp; Delivery Window</h3>',
      '    <p>We offer you the convenience of picking up your order. <strong>Prehung doors</strong> are produced and ready for pickup within <strong>72 hours</strong>. <strong>Odd size interior doors</strong> (12", 14", 16", 20", 22", 34") are <strong>2–3 weeks</strong> delivery.</p>',
      '    <p>Moulding, flooring, interior door slabs, select interior prehung doors, and in-stock exterior doors are <strong>ready to pick up any time</strong>. <strong>Tarkett Fiberfloor</strong> is ready for pickup within <strong>24 hours</strong>.</p>',
      '    <p>We will notify you by email once your order is complete and ready for pickup or delivery. Customers picking up must present photo identification.</p>',
      '  </div>',

      '  <div class="calc-popup__section calc-popup__section--warning">',
      '    <h3 class="calc-popup__section-title">⚠️ Final Sale Policy</h3>',
      '    <p>All interior doors, prehung door units, exterior entrance systems, moulding, vinyl sheet, and special order materials are <strong>FINAL SALE</strong>. These materials are NOT eligible for return, exchange or credit.</p>',
      '    <p>Material eligible for return is subject to a <strong>20% restocking fee</strong>. Please verify all measurements carefully before placing your order.</p>',
      '  </div>',
      '',
      '  <div class="calc-popup__section">',
      '    <h3 class="calc-popup__section-title">📍 Orders Outside Service Area</h3>',
      '    <p>If you are located outside our standard delivery zone, please contact our store directly for a custom shipping quote before or after ordering.</p>',
      '    <p>📞 Phone: <a href="tel:+19022703770"><strong>(902) 270-3770</strong></a></p>',
      '    <p>🕒 <strong>Business Hours:</strong> Monday – Friday: 8:00 AM – 5:00 PM | Saturday: 9:00 AM – 2:00 PM</p>',
      '  </div>',

      '  <div class="calc-popup__acknowledge" id="calc-popup-ack">',
      '    <p class="calc-popup__ack-label">By entering your initials below, you acknowledge that you have read and understood the final sale policy above.</p>',
      '    <div class="calc-popup__ack-row">',
      '      <input',
      '        type="text"',
      '        id="calc-popup-initials"',
      '        class="calc-popup__initials"',
      '        placeholder="Your initials (e.g. PK)"',
      '        maxlength="4"',
      '        autocomplete="off"',
      '      >',
      '      <button',
      '        type="button"',
      '        id="calc-popup-ack-btn"',
      '        class="calc-popup__ack-btn"',
      '        disabled',
      '      >',
      '        I Acknowledge &amp; Accept',
      '      </button>',
      '    </div>',
      '    <p class="calc-popup__ack-hint" id="calc-popup-ack-hint">Please enter your initials to continue.</p>',
      '  </div>',

      '</div>'
    ].join('\n');

    document.body.appendChild(modal);
    return modal;
  }

  /* ─────────────────────────────────────────
     POLICY ACKNOWLEDGMENT (OPTIONAL VIA ❓ POPUP)
  ───────────────────────────────────────── */

  function applyInitialsToForms(initials) {
    document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]').forEach(function (form) {
      var existing = form.querySelector('[name="properties[Acknowledged By]"]');
      if (!existing) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Acknowledged By]';
        input.value = initials.toUpperCase();
        form.appendChild(input);
      } else {
        existing.value = initials.toUpperCase();
      }
    });
  }

  function unlockAddToCart(initials) {
    sessionStorage.setItem(ACKNOWLEDGED_KEY, initials);
    applyInitialsToForms(initials);
  }

  /* ─────────────────────────────────────────
     MODAL OPEN / CLOSE
  ───────────────────────────────────────── */

  function openModal() {
    var modal = buildModal();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var initialsInput = document.getElementById('calc-popup-initials');
    var ackBtn = document.getElementById('calc-popup-ack-btn');
    var ackHint = document.getElementById('calc-popup-ack-hint');

    // Already acknowledged?
    var savedInitials = sessionStorage.getItem(ACKNOWLEDGED_KEY);
    if (savedInitials) {
      var ackSection = document.getElementById('calc-popup-ack');
      if (ackSection) {
        ackSection.innerHTML = [
          '<div class="calc-popup__ack-confirmed">',
          '  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2d7a2d" stroke-width="2"><polyline points="20,6 9,17 4,12"/></svg>',
          '  <span>Policy acknowledged by: <strong>' + savedInitials.toUpperCase() + '</strong></span>',
          '</div>'
        ].join('');
      }
      return;
    }

    // Enable ack button when initials typed
    if (initialsInput) {
      initialsInput.addEventListener('input', function () {
        var val = this.value.trim();
        if (val.length >= 2) {
          ackBtn.disabled = false;
          ackHint.textContent = '';
        } else {
          ackBtn.disabled = true;
          ackHint.textContent = 'Please enter at least 2 initials.';
        }
      });
    }

    if (ackBtn) {
      ackBtn.addEventListener('click', function () {
        var initials = initialsInput ? initialsInput.value.trim() : '';
        if (initials.length < 2) return;
        unlockAddToCart(initials);
        closeModal();

        // Show brief confirmation
        showCalcToast('✓ Policy acknowledged. You can now add items to cart.');
      });
    }

    // Close on overlay click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    // Close button
    var closeBtn = document.getElementById('calc-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Focus first interactive element
    if (initialsInput) setTimeout(function () { initialsInput.focus(); }, 100);
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* ─────────────────────────────────────────
     BIND INFO (❓) BUTTONS
  ───────────────────────────────────────── */

  function bindInfoButtons() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.calc__info-btn')) {
        openModal();
      }
    });
  }

  function showCalcToast(msg) {
    var toast = document.getElementById('calc-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'calc-toast';
      toast.className = 'calc-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('calc-toast--visible');
    setTimeout(function () {
      toast.classList.remove('calc-toast--visible');
    }, 3500);
  }

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */

  function init() {
    var alreadyAcknowledged = sessionStorage.getItem(ACKNOWLEDGED_KEY);
    if (alreadyAcknowledged) {
      applyInitialsToForms(alreadyAcknowledged);
    }

    bindInfoButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
